//
// Video floating strategy.
function AdsNinjaFloatingStrategySingleVideo(logger, options = {}, callbacks = {}){

    AdsNinjaFloatingStrategy.call(this, logger, options, callbacks);
}

AdsNinjaFloatingStrategySingleVideo.prototype             = Object.create(AdsNinjaFloatingStrategy.prototype);
AdsNinjaFloatingStrategySingleVideo.prototype.constructor = AdsNinjaFloatingStrategySingleVideo;


//
// Handle request to float.
AdsNinjaFloatingStrategySingleVideo.prototype.handleRequestToFloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    var foundInfo = state[requestDetails.originalElementId];

    if(foundInfo){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.warn('Float request rejected. Ad is already floating.', returnResult);

        return returnResult;
    }

    var allAdsDefloated = true;
    var returnResult    = null;

    // Validate requestor is the user if an element is currently showing.
    var currentlyShowingUserRequestedElement = adTypeMapping[requestDetails.adType].some(function(element){

        return (element.requestor === window.AdsNinjaFloatingManager.prototype.REQUESTOR_USER); 
    });

    if(currentlyShowingUserRequestedElement && requestDetails.requestor !== window.AdsNinjaFloatingManager.prototype.REQUESTOR_USER){

        floatAdTypeRequestQueue[requestDetails.adType].push(requestDetails);
        floatPositionRequestQueue[requestDetails.position].push(requestDetails);

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.debug('Float request failed. User is not the requestor.', returnResult);

        return returnResult;
    } 

    var indexOfDisabledElement = disabledElements.indexOf(requestDetails.originalElementId);
    
    if(-1 !== indexOfDisabledElement){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.debug('Float request failed. Element is not allowed to float.', returnResult);

        return returnResult;
    }

    for(var i = 0; i < adTypeMapping[requestDetails.adType].length; i++){

        var foundelementId = adTypeMapping[requestDetails.adType][i];
        var defloatInfo    = state[foundelementId];

        if(!defloatInfo){

            this.__logger.warn(`No defloating info found for element ID: ${foundelementId}.`);

            delete state[foundelementId];

            continue;
        }

        var defloatRequestDetails = {
            elementId: defloatInfo.originalElementId, 
            adType: defloatInfo.adType, 
            position: defloatInfo.position, 
            floatType: defloatInfo.floatType, 
            requestor: defloatInfo.requestor, 
            context: window.AdsNinjaFloatingManager.prototype.CONTEXT_SUSPEND,
            floatCallback: defloatInfo.floatCallback,
            defloatCallback: defloatInfo.defloatCallback,
        };

        // Defloat old element.
        var defloatResult = this.handleRequestToDefloat(
            defloatRequestDetails,
            adTypeMapping,
            floatAdTypeRequestQueue,
            positionMapping,
            floatPositionRequestQueue,
            state,
            disabledElements,
            false
        ); 

        defloatRequestDetails     = defloatResult.requestDetails;
        adTypeMapping             = defloatResult.adTypeMapping; 
        floatAdTypeRequestQueue   = defloatResult.floatAdTypeRequestQueue;
        positionMapping           = defloatResult.positionMapping;
        floatPositionRequestQueue = defloatResult.floatPositionRequestQueue;
        state                     = defloatResult.state;
        disabledElements          = defloatResult.disabledElements;
        allAdsDefloated           = (allAdsDefloated && defloatResult.requestApproved);

        if(!defloatResult.requestApproved){

            continue;
        }

        // Add element to queues.
        var updateQueuesResult    = this._updateStateAfterPriorityRequestToFloat(defloatRequestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
        defloatRequestDetails     = updateQueuesResult.requestDetails;
        adTypeMapping             = updateQueuesResult.adTypeMapping;
        floatAdTypeRequestQueue   = updateQueuesResult.floatAdTypeRequestQueue;
        positionMapping           = updateQueuesResult.positionMapping;
        floatPositionRequestQueue = updateQueuesResult.floatPositionRequestQueue;
        state                     = updateQueuesResult.state;
        disabledElements          = updateQueuesResult.disabledElements;
    }

    if(!allAdsDefloated){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.warn('Float request failed. All ads were not defloated.', returnResult);

        return returnResult;
    }

    var floatResult = requestDetails.floatCallback(requestDetails.context);

    if(floatResult !== null && !floatResult){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        // TODO: Fallback.
        this.__logger.warn('Float request failed. No fallback implemented.', returnResult);

        // // TODO: Defloat.
        // // TODO: Try to float previous one.
        // var floatFallbackResult = this.requestToFloat(
        //     currentInfo['elementId'], 
        //     currentInfo['adType'], 
        //     currentInfo['position'], 
        //     currentInfo['floatType'], 
        //     this.REQUESTOR_MANAGER, 
        //     floatCallback, 
        //     defloatCallback
        // );
        // if(floatFallbackResult){

        //     this.__logger.warn('Float request failed. Fallback to float request was successful.', {
        //         elementId: elementId,
        //         adType: adType,
        //         position: position,
        //         requestor: requestor,
        //         floatType: floatType,
        //         floatCallback: floatCallback,
        //         defloatCallback: defloatCallback,   
        //     });
        // }
        // else{

        //     this.__logger.warn('Float request failed. Fallback to float request was not successful.', {
        //         elementId: elementId,
        //         adType: adType,
        //         position: position,
        //         requestor: requestor,
        //         floatType: floatType,
        //         floatCallback: floatCallback,
        //         defloatCallback: defloatCallback,   
        //     });
        // }

        return returnResult;
    }

    var updatedStateResult    = this._updateStateAfterRequestToFloat(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
    requestDetails            = updatedStateResult.requestDetails;
    adTypeMapping             = updatedStateResult.adTypeMapping;
    floatAdTypeRequestQueue   = updatedStateResult.floatAdTypeRequestQueue;
    positionMapping           = updatedStateResult.positionMapping;
    floatPositionRequestQueue = updatedStateResult.floatPositionRequestQueue;
    state                     = updatedStateResult.state;
    disabledElements          = updatedStateResult.disabledElements;

    return this.__resultHelper(true, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
};

//
// Handle request to defloat.
AdsNinjaFloatingStrategySingleVideo.prototype.handleRequestToDefloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements, floatNextAvailableElement = true){

    var foundInfo = state[requestDetails.originalElementId];

    if(!foundInfo){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        this.__logger.warn('Defloat request rejected. Ad is not floating.', returnResult);

        return returnResult;
    }

    var defloatResult = requestDetails.defloatCallback(requestDetails.context);

    if(defloatResult !== null && !defloatResult){

        returnResult = this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

        // TODO: Fallback.
        this.__logger.warn('Defloat request failed. No fallback implemented.', returnResult);

        return returnResult;
    }

    var updatedStateResult    = this._updateStateAfterRequestToDefloat(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
    requestDetails            = updatedStateResult.requestDetails;
    adTypeMapping             = updatedStateResult.adTypeMapping;
    floatAdTypeRequestQueue   = updatedStateResult.floatAdTypeRequestQueue;
    positionMapping           = updatedStateResult.positionMapping;
    floatPositionRequestQueue = updatedStateResult.floatPositionRequestQueue;
    state                     = updatedStateResult.state;
    disabledElements          = updatedStateResult.disabledElements;

    // Float next element.
    if(floatNextAvailableElement){

        var floatNextAvailableElementResult = this._floatNextAvailableElement(
            requestDetails, 
            adTypeMapping, 
            floatAdTypeRequestQueue, 
            positionMapping, 
            floatPositionRequestQueue, 
            state,
            disabledElements
        );

        requestDetails            = floatNextAvailableElementResult.requestDetails;
        adTypeMapping             = floatNextAvailableElementResult.adTypeMapping;
        floatAdTypeRequestQueue   = floatNextAvailableElementResult.floatAdTypeRequestQueue;
        positionMapping           = floatNextAvailableElementResult.positionMapping;
        floatPositionRequestQueue = floatNextAvailableElementResult.floatPositionRequestQueue;
        state                     = floatNextAvailableElementResult.state;
        disabledElements          = floatNextAvailableElementResult.disabledElements;
    }

    return this.__resultHelper(true, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
};

//
// Handle enable element.
AdsNinjaFloatingStrategySingleVideo.prototype.handleEnableElement = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    var parentResult = AdsNinjaFloatingStrategy.prototype.handleEnableElement.call(this, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);

    if(!parentResult){

        return {
            requestDetails: requestDetails,
            adTypeMapping: adTypeMapping,
            floatAdTypeRequestQueue: floatAdTypeRequestQueue,
            positionMapping: positionMapping,
            floatPositionRequestQueue: floatPositionRequestQueue,
            state: state,
            disabledElements: disabledElements,
        }
    }

    requestDetails            = parentResult.requestDetails;
    adTypeMapping             = parentResult.adTypeMapping;
    floatAdTypeRequestQueue   = parentResult.floatAdTypeRequestQueue;
    positionMapping           = parentResult.positionMapping;
    floatPositionRequestQueue = parentResult.floatPositionRequestQueue;
    state                     = parentResult.state;
    disabledElements          = parentResult.disabledElements;
    var first                 = true;

    // Don't defloat none user elements.
    if(requestDetails.requestor === window.AdsNinjaFloatingManager.prototype.REQUESTOR_USER){

        for(var i = 0; i < adTypeMapping[requestDetails.adType].length; i++){

            var foundelementId = adTypeMapping[requestDetails.adType][i];
            var foundInfo      = state[foundelementId];
    
            if(!foundInfo || foundInfo.originalElementId === requestDetails.originalElementId){
    
                continue;
            }
    
            // Don't defloat none user elements.
            if(foundInfo.requestor !== window.AdsNinjaFloatingManager.prototype.REQUESTOR_USER){
    
                continue;
            }
    
            var defloatRequestDetails = {
                elementId: foundInfo.originalElementId, 
                adType: foundInfo.adType, 
                position: foundInfo.position, 
                floatType: foundInfo.floatType, 
                requestor: requestDetails.requestor, 
                context: window.AdsNinjaFloatingManager.prototype.CONTEXT_SUSPEND,
                floatCallback: foundInfo.floatCallback,
                defloatCallback: foundInfo.defloatCallback,
            };
    
            // Defloat old element.
            var defloatResult = this.handleRequestToDefloat(
                defloatRequestDetails,
                adTypeMapping,
                floatAdTypeRequestQueue,
                positionMapping,
                floatPositionRequestQueue,
                state,
                disabledElements,
                first
            ); 
    
            first                     = false;
            defloatRequestDetails     = defloatResult.requestDetails;
            adTypeMapping             = defloatResult.adTypeMapping; 
            floatAdTypeRequestQueue   = defloatResult.floatAdTypeRequestQueue;
            positionMapping           = defloatResult.positionMapping;
            floatPositionRequestQueue = defloatResult.floatPositionRequestQueue;
            state                     = defloatResult.state;
            disabledElements          = defloatResult.disabledElements;
    
            // Disable old element.
            var disableResult = this.handleDisableElement(
                defloatRequestDetails,
                adTypeMapping,
                floatAdTypeRequestQueue,
                positionMapping,
                floatPositionRequestQueue,
                state,
                disabledElements
            );
    
            defloatRequestDetails     = disableResult.requestDetails;
            adTypeMapping             = disableResult.adTypeMapping;
            floatAdTypeRequestQueue   = disableResult.floatAdTypeRequestQueue;
            positionMapping           = disableResult.positionMapping;
            floatPositionRequestQueue = disableResult.floatPositionRequestQueue;
            state                     = disableResult.state;
            disabledElements          = disableResult.disabledElements;
        }
    }
    
    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    }
};

//
// Float next available element.
AdsNinjaFloatingStrategySingleVideo.prototype._floatNextAvailableElement = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){

    if(!floatAdTypeRequestQueue[requestDetails.adType] || floatAdTypeRequestQueue[requestDetails.adType].length === 0){

        return this.__resultHelper(false, requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements);
    }

    for(var i = 0; i < floatAdTypeRequestQueue[requestDetails.adType].length; i++){
        
        var requestDetails = floatAdTypeRequestQueue[requestDetails.adType][i];

        if(!requestDetails){

            delete floatAdTypeRequestQueue[requestDetails.adType][i];

            floatPositionRequestQueue[requestDetails.position].unshift();

            continue;
        }
        else if(disabledElements.indexOf(requestDetails.originalElementId) !== -1){

            continue;
        }

        var floatResult = this.handleRequestToFloat(
            requestDetails, 
            adTypeMapping, 
            floatAdTypeRequestQueue, 
            positionMapping, 
            floatPositionRequestQueue, 
            state,
            disabledElements
        );

        if(floatResult.requestApproved){

            floatAdTypeRequestQueue[requestDetails.adType] = floatAdTypeRequestQueue[requestDetails.adType].filter(function(element){

                return requestDetails.originalElementId !== element.originalElementId;
            });
        
            floatPositionRequestQueue[requestDetails.position] = floatPositionRequestQueue[requestDetails.position].filter(function(element){
        
                return requestDetails.originalElementId !== element.originalElementId;
            });

            break;
        }
        else{
            
            this.__logger.warn('Float request failed. Failed to float next available element.', requestDetails);
        }
    }

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

//
// Update state.
AdsNinjaFloatingStrategySingleVideo.prototype._updateStateAfterPriorityRequestToFloat = function(requestDetails, adTypeMapping, floatAdTypeRequestQueue, positionMapping, floatPositionRequestQueue, state, disabledElements){
    
    requestDetails.context = window.AdsNinjaFloatingManager.prototype.CONTEXT_RESUME;

    floatAdTypeRequestQueue[requestDetails.adType].unshift(requestDetails);
    floatPositionRequestQueue[requestDetails.position].unshift(requestDetails);

    if(requestDetails.requestor === window.AdsNinjaFloatingManager.prototype.REQUESTOR_USER && -1 === disabledElements.indexOf(requestDetails.originalElementId)){

        disabledElements.push(requestDetails.originalElementId);
    }

    return {
        requestDetails: requestDetails,
        adTypeMapping: adTypeMapping,
        floatAdTypeRequestQueue: floatAdTypeRequestQueue,
        positionMapping: positionMapping,
        floatPositionRequestQueue: floatPositionRequestQueue,
        state: state,
        disabledElements: disabledElements,
    };
};

window.AdsNinjaFloatingStrategySingleVideo = AdsNinjaFloatingStrategySingleVideo;